import React from "react";
import "./ImpDoc.css";
const ImpDoc = () => {
  return (
    <div className="impDocContainer">
      <h2>Importance of Commercial Document <span>Attestation</span></h2>
      <p>
        Commercial document attestation plays a pivotal role in global trade and
        business transactions:
      </p>
      <ul>
        <li>
          <span>Legal Compliance:</span> Attested documents ensure compliance
          with international laws and regulations, mitigating legal risks and
          liabilities.
        </li>
        <li>
          <span>Global Recognition:</span> Attestation enhances the credibility
          and recognition of documents across borders, facilitating smoother
          transactions and partnerships.
        </li>
        <li>
          <span>Business Expansion:</span> Verified documents are essential for
          establishing new business entities, acquiring licenses, and
          participating in international tenders.
        </li>
        <li>
          <span>Risk Mitigation:</span> Prevents fraud and ensures the accuracy
          of business records, safeguarding against potential financial and
          reputational risks.
        </li>
      </ul>
    </div>
  );
};

export default ImpDoc;
